import { z } from 'zod'
import { zId, zIsoDate } from '../common'

// A site. `hasApiKey` replaces the key itself — the API key is never readable
// again after generation, so the front only knows whether one exists.
export const zProperty = z.object({
  id: zId,
  tenantId: zId,
  name: z.string(),
  slug: z.string(),
  status: z.string(),
  domain: z.string().nullable(),
  // Conversion-tracking config. `fallbackUrl` is where a click is sent when no
  // active affiliate link exists; `googleConversionActionId` names the Google
  // Ads conversion action uploads are booked against. Both nullable and
  // additive/defaulted so an older backend response still parses cleanly.
  fallbackUrl: z.string().nullable().default(null),
  googleConversionActionId: z.string().nullable().default(null),
  hasApiKey: z.boolean(),
  createdAt: zIsoDate,
  updatedAt: zIsoDate,
})
export type Property = z.infer<typeof zProperty>

// POST /properties/:id/generate_api_key → { apiKey }. Returned in clear exactly
// ONCE. Only its fingerprint is stored; if the front does not show it, it is
// lost and must be regenerated (which breaks the site in production).
export const zGeneratedApiKey = z.object({
  apiKey: z.string(),
})
export type GeneratedApiKey = z.infer<typeof zGeneratedApiKey>
